export default __webpack_public_path__ + "static/media/Kollektiv35_StimmeX_Web-43.8c61d889.jpg";